import React from 'react';
import Routers from './routers';
import FlowDetailsProvider from './providers/flowDetails-provider';
import TasksProvider from './providers/tasks-provider';
import FilterProvider from './providers/filterData-provider';

const App = () => {
  return (
    <div>
      <FilterProvider>
        <FlowDetailsProvider>
          <TasksProvider>
            <Routers />
          </TasksProvider>
        </FlowDetailsProvider>
      </FilterProvider>
    </div>
  )
}

export default App;
